import type { Suggestion } from '../autocompletion-types.js';
import {
  regexFromSuggestions,
  regexFromPrefixAndSuggestions,
} from '../regex-utils.js';
import type { ListAutocompletionConfig } from './list-autocompletion-types.js';

export interface SuggestionData {
  suggestions: Suggestion[];
  prefixRegex: RegExp;
  suggestionRegex: RegExp;
}

/** Creates suggestion data from suggestions. */
export async function createSuggestionData(
  autocompletionList: ListAutocompletionConfig,
): Promise<SuggestionData | undefined> {
  try {
    const suggestions =
      typeof autocompletionList.autocompletionList === 'function'
        ? await autocompletionList.autocompletionList()
        : autocompletionList.autocompletionList;
    const suggestionRegex = regexFromSuggestions(suggestions);
    return {
      suggestions,
      suggestionRegex,
      prefixRegex: regexFromPrefixAndSuggestions(
        autocompletionList.matchBefore,
        suggestionRegex,
      ),
    };
  } catch {
    return undefined;
  }
}
